import React, { useState } from "react";
// import { logout } from '../../services/auth';
import { onSignOut } from "../auth/index";

import { alpha, styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Button, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

export default function Header({ openMenu, abrir, userName, menus, currentGroup, history }) {
  const [anchorElGroups, setAnchorElGroups] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const openGroupSelect = Boolean(anchorElGroups);
  const openButton = Boolean(anchorEl);
  // const [User, setUser] = useState('Usuário'); //que virá do contexto

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const abrirGrupo = grupo => {
    setAnchorElGroups(null);
    history.push(`/app/${grupo.rotaInicial}`);
  }

  // const handleDrawerOpen = () => {
  //   openMenu();
  // };

  const sair = () => {
    onSignOut();
    // history.push('/');
    history.go(0);
  };

  return (
    <AppBar position="fixed" open={abrir}>
      <Toolbar>
        <IconButton
            color="text"
            aria-label="open drawer"
            onClick={openMenu}
            edge="start"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>     
        {/* <span style={{ fontWeight: "bolder", color: "white" }}>
          Bilíngue
        </span> */}
        {/* {currentGroup.nome &&
          <Button
            id="demo-customized-button"
            aria-controls="demo-customized-menu"
            aria-haspopup="true"
            aria-expanded={openGroupSelect ? "true" : undefined}
            variant="contained"
            disableElevation
            onClick={e => setAnchorElGroups(e.currentTarget)}
            endIcon={<KeyboardArrowDownIcon />}
            style={{ color: "white", fontWeight: 'bolder', fontSize: 20, textTransform: 'none'}}
          >
            {currentGroup.nome}
          </Button>
        } */}
        <h4 style={{color: 'white', fontWeight: 'bolder'}}>Painel da Escola</h4>
        
        <StyledMenu
          id="product-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorElGroups}
          open={openGroupSelect}
          onClose={() => setAnchorElGroups(null)}
        >
          <h4 style={{marginLeft: 15}}>Produto Perto:</h4>
          {menus.filter(grupo => grupo.id !== currentGroup.id).map(grupo => 
              <MenuItem onClick={() => abrirGrupo(grupo)} disableRipple>
                {grupo.nome}
              </MenuItem>
            )}          
        </StyledMenu>

        <Button
          id="demo-customized-button"
          aria-controls="demo-customized-menu"
          aria-haspopup="true"
          aria-expanded={openButton ? "true" : undefined}
          variant="contained"
          disableElevation
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
          style={{ marginLeft: "auto", color: "white" }}
          startIcon={<AccountCircleIcon />}
        >
          {userName}
        </Button>

        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorEl}
          open={openButton}
          onClose={handleClose}
        >
          <MenuItem onClick={sair} disableRipple>
            Sair
          </MenuItem>
        </StyledMenu>
      </Toolbar>
    </AppBar>
  );
}
const drawerWidth = 275;

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
